/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({

    paymentSuccess:{
        id: 'quoteandbind.RecVehProduct.view.Success.Payment Successful',
        defaultMessage: 'Payment Successful'
    },
    confirmationTextLabel:{
        id: 'quoteandbind.RecVehProduct.views.confirmation.PolicyApprovedEmailShortly',
        defaultMessage: 'Your new policy has been approved. You will receive an email confirmation shortly'
    },
    policySummaryLabel:{
        id:'quoteandbind.RecVehProduct.view.Success.PolicySummary',
        defaultMessage: 'Policy Summary'
    },
    accountNumberLabel:{
        id:'quoteandbind.RecVehProduct.view.Success.AccountNumber',
        defaultMessage:'Account Number'
    },
    policyNumberLabel:{
        id:'quoteandbind.RecVehProduct.view.Success.PolicyNumber',
        defaultMessage:'Policy Number'
    },
    policyEffectiveDate:{
        id:'quoteandbind.policy-details.Coverage Start Date',
        defaultMessage:'Policy Effective Date'
    },
    policyExpirationDate:{
        id: 'quoteandbind.policy-details.Coverage End Date',
        defaultMessage: 'Expiration Date'
    },
    policyTotAmt: {
        id: 'quoteandbind.RecVehProduct.view.Success.PolicyTotalAmount',
        defaultMessage: 'Policy Total Amount'
    },
    vehicleDetails: {
        id: 'quoteandbind.common.views.Success.VehicleDetails',
        defaultMessage: 'Vehicle Details'
    },
    coveragesTitle:{
        id: 'quoteandbind.common.views.Success.Coverages',
        defaultMessage: 'Coverages'
    },
    endorsementCoverages:{
        id: 'quoteandbind.common.views.Success.Endorsement Coverages',
        defaultMessage: 'Endorsement Coverages'
    },
    contactInfoDetails:{
        id: 'quoteandbind.RecVehProduct.view.Success.ContactInformationDetails',
        defaultMessage: 'Contact Information Details'
    },
    namedInsuredLabel:{
        id: 'quoteandbind.RecVehProduct.view.Success.NamedInsured',
        defaultMessage: 'Name'
    },
    emailLabel:{
        id: 'quoteandbind.RecVehProduct.view.Success.Email',
        defaultMessage: 'Email'
    },
    addressLabel:{
        id: 'quoteandbind.RecVehProduct.view.Success.Address',
        defaultMessage: 'Address'
    },

});
